import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';

import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetPayorBO } from './payer.modal';

@Injectable({
  providedIn: 'root'
})
export class PayerDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(Payerstate: GetPayorBO): void {
    this.getPayerList(Payerstate).subscribe(x => super.next(x));
  }
  getPayerList(Payerstate?: GetPayorBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Payer/GetGroupPayorListFilter?", Payerstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
